/**
 * События аналитики (Umami через свой домен, I3). Имя события — `name`, свойства — `props` (Umami `track(name, data)`).
 * Никаких личных данных: ни Telegram id, ни имени, ни initData. Частота — только перечисленные моменты, не каждый тик.
 */
import { z } from "zod";
import { Platform } from "../common";
import { paymentsEvents } from "./payments";
import { sessionEvents } from "./session";
import { wavesEvents } from "./waves";
import { windowsEvents } from "./windows";

export { Platform };
export * from "./common";

/** Событие аналитики. Новое событие — строка в `<домен>.ts`. */
export const AnalyticsEvent = z.discriminatedUnion("name", [
  ...paymentsEvents,
  ...sessionEvents,
  ...wavesEvents,
  ...windowsEvents,
]);
export type AnalyticsEvent = z.infer<typeof AnalyticsEvent>;
export type AnalyticsEventName = AnalyticsEvent["name"];
